import {createProperty} from './utils/createProperty'

/**
 * The annotation builder for a component property with type 'Array'.
 */
export const array = createProperty('array').array
